(function(angular){
	'use strict';
	
	angular
		.module('formValidationModule')
		.directive('savingsAccountPermitted', [
			'$parse',
			savingsAccountPermittedFunction
		]);
	
	function savingsAccountPermittedFunction($parse) {
		return {
			require: 'ngModel',
			restrict: 'A',
			link: function($scope, $elem, $attrs, ngModel) {
				
				$scope.$watch($attrs.ngModel, function(newValue) {
					if(angular.isDefined(newValue)) {
						var accountType = $parse($attrs.ngModel)($scope).accountType;
						var savingsAccountPermitted = $parse($attrs.savingsAccountPermitted)($scope);
						var isValid = (accountType !== 'SAVINGS') || savingsAccountPermitted;

						ngModel.$setValidity('savingsAccountPermitted', isValid);
						ngModel.$setTouched();
					}
				});
			}
		};
	}
})(window.angular);